import { gql } from "@apollo/client";

/**
 * IoT attach gate of an asset (IBM-1039): the backend folds the effective
 * network scan (GREEN) and the structural rules (asset inside a gateway
 * system, non-current location) into `canAttachIotConnection`; the scan and
 * its source explain a "no". `pathNodes` lets the reason view jump to the
 * documenting node in the installed base. Only sent while
 * REACT_APP_ENABLE_SLA is on (callers `skip` otherwise) so the
 * document never reaches a gateway without these fields.
 */
export const AssetLocationIotGate = gql`
    query AssetLocationIotGate($id: ID!) {
        assetLocation(id: $id) {
            id
            canAttachIotConnection
            effectiveNetworkScan {
                state
                scanDate
                source {
                    installedBaseNodeId
                    nodeTypeKey
                    name
                }
            }
            installedBaseNode {
                id
                pathNodes {
                    id
                }
            }
        }
    }
`;
